// Per-map debris palette (owner 2026-11-02: 'snow and lava maps still show green leaves and brown debris'). Render-only.
// A map's MapRenderDef.debris overrides any of these; the view applies it on every map change (setDebrisLook), and the
// debris / blast / Zenith effects read the active palette when they emit. Defaults = the original Canyon Meadow colours.
import * as THREE from 'three/webgpu';

export interface DebrisLook {
  /** falling leaf cards when a tree or bush is hit, felled or lands */
  leaves: number[];
  /** charred leaf / ash flakes (burnt flora) and ash rubble */
  ash: number[];
  /** blast grit, Nova Lance trench chips, Surge swirl pebbles, Zenith soil */
  grit: number[];
  /** big-blast ground slabs (turf / crust torn up), Zenith turf */
  turf: number[];
  /** blast dust skirt and dust curtain */
  dust: number;
  /** dirt clods (uprooted trees, bushes torn out, root holes) */
  clod: number;
  /** stone chips knocked off rocks / boulders / spires */
  chip: number;
  /** rubble piles left by broken spire / boulder / rock */
  rubble: [number, number, number];
  /** optional soft puffs when foliage is hit (snow shaken off branches); omit = none */
  puff?: number;
}

export const DEFAULT_DEBRIS: DebrisLook = {
  leaves: [0x2b6129, 0x4f8238, 0x86a854, 0x17452a],
  ash: [0x2a2420, 0x3b322b, 0x1a1512, 0x4a3e34],
  grit: [0xb07a52, 0xc99a6a, 0x8f6446, 0xd8b58a, 0x6e5a48],
  turf: [0x8a6a44, 0xa98c5e, 0x5c8a3a, 0x7a5a3a],
  dust: 0xc2a77f,
  clod: 0x6a4a30,
  chip: 0xb08a64,
  rubble: [0xc49a6c, 0x9a8670, 0xa8957c],
};

/** the active palette (THREE.Color arrays for the per-particle copies); mutated in place by setDebrisLook */
export const DEBRIS = {
  look: DEFAULT_DEBRIS,
  leaves: [] as THREE.Color[], grit: [] as THREE.Color[], turf: [] as THREE.Color[], dust: new THREE.Color(),
};

/** Apply a map's palette (missing fields fall back to the defaults). */
export function setDebrisLook(o?: Partial<DebrisLook>): void {
  const L: DebrisLook = o && o !== DEFAULT_DEBRIS && Object.keys(o).length ? { ...DEFAULT_DEBRIS, ...o } : DEFAULT_DEBRIS;
  DEBRIS.look = L;
  DEBRIS.leaves = L.leaves.map((h) => new THREE.Color(h));
  DEBRIS.grit = L.grit.map((h) => new THREE.Color(h));
  DEBRIS.turf = L.turf.map((h) => new THREE.Color(h));
  DEBRIS.dust.setHex(L.dust);
}
setDebrisLook();
